import { render, staticRenderFns } from "./PermissionDetails.vue?vue&type=template&id=0ef7f57a&"
import script from "./PermissionDetails.vue?vue&type=script&lang=js&"
export * from "./PermissionDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src3358805848/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0ef7f57a')) {
      api.createRecord('0ef7f57a', component.options)
    } else {
      api.reload('0ef7f57a', component.options)
    }
    module.hot.accept("./PermissionDetails.vue?vue&type=template&id=0ef7f57a&", function () {
      api.rerender('0ef7f57a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/containers/Config/PermissionDetails.vue"
export default component.exports